import { motion } from "framer-motion";

export const TONES = {
  neutral: "border-border bg-card",
  data: "border-brand-data/60 bg-brand-data/10",
  primary: "border-brand-primary/60 bg-brand-primary/10",
  accent: "border-brand-accent/60 bg-brand-accent/10",
  action: "border-brand-action/70 bg-brand-action/15",
  danger: "border-destructive/60 bg-destructive/10",
  trust: "border-trust bg-trust text-white",
};

export const Frame = ({ title, hint, children, testId }) => (
  <div data-testid={testId} className="not-prose font-body">
    <div className="mb-4 flex flex-wrap items-baseline justify-between gap-2">
      <div className="font-heading text-sm font-bold uppercase tracking-widest">{title}</div>
      {hint && <div className="font-mono text-[11px] uppercase tracking-wider text-brand-primary">{hint}</div>}
    </div>
    {children}
  </div>
);

export const Node = ({ active, dim, tone = "neutral", onClick, children, testId, className = "" }) => (
  <motion.button
    type="button"
    layout
    onClick={onClick}
    data-testid={testId}
    aria-pressed={!!active}
    whileHover={{ y: -2 }}
    className={`w-full border p-3 text-left text-xs leading-snug transition-colors sm:text-sm ${TONES[tone]} ${active ? "ring-2 ring-brand-primary ring-offset-2 ring-offset-background" : ""} ${dim ? "opacity-35" : ""} ${className}`}
  >
    {children}
  </motion.button>
);

export const Flow = ({ on = true, vertical = false }) => (
  <div className={`flex items-center justify-center ${vertical ? "h-6" : "h-6 sm:h-auto sm:w-6"}`} aria-hidden>
    <div className={`${vertical ? "h-full w-px" : "h-full w-px sm:h-px sm:w-full"} ${on ? "pulse-line bg-brand-primary" : "bg-border"}`} />
  </div>
);

export const Detail = ({ children, testId }) => (
  <motion.div key={String(testId) + String(children?.key)} initial={{ opacity: 0, y: 6 }} animate={{ opacity: 1, y: 0 }} data-testid={testId} className="mt-5 border-l-4 border-brand-action bg-card p-4 text-sm leading-relaxed">
    {children}
  </motion.div>
);
